import { BaseService } from "@/service";
import { checkResult } from "@/common";
import base from "@/service/base";

export const getOrgsByName = async function (name) {
    const res = await BaseService.list({
        table: "thtt_organization",
        columns: "organization_id,name",
        where: {
            name: name,
            is_delete: 0,
        },
    });
    return res.data.result;
}

/**
 * 根据机构/企业名称返回 id，如果不存在就新建一个
 * @param {String} name 机构/企业名称
 * @param {String} userId 用户ID，当机构不存在时用于创建机构
 */
export const returnOrAddOrgIdByName = async function (name, userId, recommendationOrgName, data = {}) {

    const list = await getOrgsByName(name);

    if (list.length) {
        const organizationId = list[0].organization_id;
        putOrg(organizationId, { recommendation: recommendationOrgName, ...data })
        // 添加机构用户
        addOrgUser(organizationId, userId);
        return organizationId;
    }

    // 新建机构
    const addRes = await addOrg(name, userId, recommendationOrgName, data);
    if (!checkResult(addRes)) return false;

    const unit_id = addRes.data.result.organization_id;
    // 添加机构管理员
    addOrgUser(unit_id, userId, 1);

    return unit_id;
}

export const addOrg = async function (name, userId, recommendationOrgName, data = {}) {
    const add_time = parseInt(new Date().getTime() / 1000);
    return await BaseService.add({
        table: "thtt_organization",
        data: {
            name,
            is_delete: 0,
            add_time,
            audit_status: 4,
            user_id: userId,
            recommendation: recommendationOrgName,
            type: 5,
            ...data
        },
        key: "organization_id",
    });
}

export const putOrg = async function (organizationId, data) {
    return await BaseService.put({
        table: "thtt_organization",
        data,
        where: { organization_id: organizationId }
    });
}

export const addOrgUser = async function (organizationId, userId, isAdmin = 0) {

    const res = await base.list({
        table: 'thtt_organization_user',
        where: {
            organization_id: organizationId,
            user_id: userId,
            is_delete: 0
        }
    })

    if (res.data.result.length) return

    const add_time = parseInt(new Date().getTime() / 1000);
    const addUserRes = await BaseService.add({
        table: "thtt_organization_user",
        data: {
            organization_id: organizationId,
            user_id: userId,
            is_admin: isAdmin,
            is_delete: 0,
            add_time,
            audit_status: 4,
        },
    });
    if (!checkResult(addUserRes)) return false;
}